import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectPasswordUpdate = createSelector([(state: AppState) => state.shared.updatePassword], updatePassword => updatePassword);
